function TermSwitcher({ terms, activeTermId, onSwitchTerm }) {
  if (terms.length <= 1) {
    const name = terms[0]?.name || ''
    return (
      <div className="term-switcher">
        <span className="term-switcher-label">{name}</span>
      </div>
    )
  }

  // Sort terms by startDate descending (empty dates sort last)
  const sorted = [...terms].sort((a, b) => {
    if (!a.startDate && !b.startDate) return 0
    if (!a.startDate) return 1
    if (!b.startDate) return -1
    return b.startDate.localeCompare(a.startDate)
  })

  return (
    <div className="term-switcher">
      <select
        className="term-switcher-select"
        value={activeTermId}
        onChange={(e) => onSwitchTerm(e.target.value)}
      >
        {sorted.map((term) => (
          <option key={term.id} value={term.id}>
            {term.name}
          </option>
        ))}
      </select>
    </div>
  )
}

export default TermSwitcher
